import * as React from "react";
import { PlasmicNewList } from "./plasmic/blank_website_mobile_first/PlasmicNewList";
import {useChangeWeekendComponent} from "./hooks/useChangeWeekendComponent";
import {AppStore} from "../useAppPullState";




const useProps = (props) => {
  // console.log('[[NewList_]] useProps::: ', props);
  const user = AppStore.useState(s => s.user);
  const weekend = useChangeWeekendComponent(props.item);
  return {
    ...props,
    img:{
      src: props.item.data.preview,
    },
    weekend: user?.roleId === 2 ? <div style={{padding: 10}}>{weekend}</div> : null,
  }
}
function NewList_(props, ref) {
  return <PlasmicNewList root={{ ref }} {...useProps(props)} />;
}

const NewList = React.forwardRef(NewList_);

export default NewList;
